import React from 'react';
import { useIntl } from 'react-intl';

import { createKeyboardClickHandler } from '@/utils/accessibility';

import { Icon } from '@/components/Icon';
import { LegacyButton } from '@/components/LegacyButton';
import { pdpMessages } from '@/messages/product';

import { CubeIcon } from '../CubeIcon';

import * as S from './View3DButton.styles';

interface View3DButtonProps {
  'data-testid'?: string;
  onOpen: () => void;
}

const View3DButton: React.FC<View3DButtonProps> = ({
  'data-testid': dataTestId,
  onOpen,
}) => {
  const { formatMessage } = useIntl();
  return (
    <S.ButtonContainer
      data-test-id='View3DButtonContainer'
      data-testid={dataTestId}
      onClick={onOpen}
      onKeyDown={createKeyboardClickHandler(onOpen)}
      role='button'
      tabIndex={0}
    >
      <S.IconContainer>
        <CubeIcon />
      </S.IconContainer>
      <LegacyButton
        label={formatMessage(pdpMessages.view3D)}
        size='l'
        variant='link'
        width='auto'
      >
        <Icon name='chevronRight' />
      </LegacyButton>
    </S.ButtonContainer>
  );
};

export default View3DButton;
